import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

import { ExpensesComponent } from '../expenses/expenses.component';
import { DepositComponent } from '../deposit/deposit.component';
import { TransferComponent } from '../transfer/transfer.component';
import { TranslateService } from '@ngx-translate/core';
import { ReturnAllDateComponent } from '../return-all-date/return-all-date.component';

@Component({
  selector: 'app-operation-list',
  templateUrl: './operation-list.component.html',
  styleUrls: ['./operation-list.component.css']
})
export class OperationListComponent implements OnInit {

  public menu_item_id = '65';

  public edit_auth;
  public del_auth;
  public view_auth;
  admin_role = false;

  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`sub_acct`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
      'condition': " AND `is_leaf` = '1' AND `is_cc` = '1'"
    }]
  };

  // search_obj = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`customer`', 'selected_no': 'customer_no',
  //       'field_list': ['customer_no', 'customer_name', 'customer_name_en']
  //     },
  //     {
  //       'table_name': '`supplier`', 'selected_no': 'supplier_no',
  //       'field_list': ['supplier_no', 'supplier_name', 'supplier_name_en']
  //     },
  //     {
  //       'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //     },
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en']
  //     },
  //     {
  //       'table_name': '`user`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'user_full_name']
  //     }
  //   ]
  // };

  private dp = [];
  displayedColumns = ['choose', 'op_type', 'op_date', 'op_total', 'partner', 'acct_number',
    'op_number', 'comment', 'op_status', 'created_by', 'view', 'edit', 'cancel', 'confirm', 'close', 'migrate'];

  displayedColumns2 = ['op_type', 'op_date', 'op_total', 'partner', 'acct_number', 'op_number', 'comment', 'op_status', 'created_by'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  expensesDialogRef: MatDialogRef<ExpensesComponent>;
  dipositDialogRef: MatDialogRef<DepositComponent>;
  transferDialogRef: MatDialogRef<TransferComponent>;
  returnDateDialogRef: MatDialogRef<ReturnAllDateComponent>;

  model = {
    'from_date': new Date(), 'to_date': new Date(), 'op_status': 'all', 'op_type': 'all', 'operation': '',
    'acct_number': '', 'user_name': 'all', 'comment': '', 'title': 'قائمة العمليات'
  };

  //*************************** Lists ***************************//

  status_list = [{ 'status': 'all', 'status_en': 'All', 'status_ar': 'الكل' },
    { 'status': '1', 'status_en': 'Saved', 'status_ar': 'محفوظة' },
    { 'status': '0', 'status_en': 'Canceled\ Fully Returned', 'status_ar': 'ملغاة/ مرجعة' },
    { 'status': '4', 'status_en': 'Migrated', 'status_ar': 'مرحلة' },
    { 'status': '5', 'status_en': 'Confirmed', 'status_ar': 'مطابقة' },
    { 'status': '3', 'status_en': 'Locked Up', 'status_ar': 'مقفلة' }];

  type_list = [{ 'op_type': 'all', 'type_ar': 'الكل', 'type_en': 'All' },
    { 'op_type': 'invoice', 'type_ar': 'فاتورة مبيعات', 'type_en': 'Invoice' },
    { 'op_type': 'supplier_invoice', 'type_ar': 'فاتورة مشتريات', 'type_en': 'Supplier Invoice' },
    { 'op_type': 'return_invoice', 'type_ar': 'مرتجع مبيعات', 'type_en': 'Return Invoice' },
    { 'op_type': 'return_supplier_invoice', 'type_ar': 'مرتجع مشتريات', 'type_en': 'Return Supplier Invoice' },
    { 'op_type': 'journal_entry', 'type_ar': 'قيود يومية', 'type_en': 'Journal Entry' },
    { 'op_type': 'cash_receipt', 'type_ar': 'سند قبض', 'type_en': 'Cash Receipt' },
    { 'op_type': 'payment_voucher', 'type_ar': 'سند صرف', 'type_en': 'Payment Voucher' },
    { 'op_type': 'expenses', 'type_ar': 'مصروفات', 'type_en': 'Expenses' },
    { 'op_type': 'deposit', 'type_ar': 'إيداع', 'type_en': 'Deposit' },
    { 'op_type': 'transfer', 'type_ar': 'تحويل', 'type_en': 'Transfer' }];

  operation_list = [{ 'operation_en': 'Cancel', 'operation_ar': 'إلغاء' },
    { 'operation_en': 'Confirm', 'operation_ar': 'مطابقة' },
    { 'operation_en': 'Close', 'operation_ar': 'إقفال' },
    { 'operation_en': 'Migrate', 'operation_ar': 'ترحيل' }];

  from_date = '';
  to_date = '';
  users = [];

  From_Date; To_Date; From_Date_Msg; To_Date_Msg;
  Success_Msg; Error_Msg; Acct_Placeholder; Change_Ops_Msg;
  Canceled_Op; Change_Op_Msg; Del_Msg; Acct_Op;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    }); 
    
    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    }); 

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Change_Ops_Msg').subscribe((res: string) => {
      this.Change_Ops_Msg = res;
    });

    translate.get('Canceled_Op').subscribe((res: string) => {
      this.Canceled_Op = res;
    });

    translate.get('Change_Op_Msg').subscribe((res: string) => {
      this.Change_Op_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Acct_Op').subscribe((res: string) => {
      this.Acct_Op = res;
    });
    this.model['title'] = this.Acct_Op;

  }

  ngOnInit() {
    this.view_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.VIEW_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    this.admin_role = (this.applicationConstants.user_info['role'] == 'admin' || this.applicationConstants.user_info['role'] == 'account');

    this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate() + ' 00:00:00';
    this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate() + ' 23:59:59';

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";
  
    let query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
        " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.model['acct_number'] = search_result['no'];
  }

  //*************************** Search ***************************//
  search() {

    if (this.model['from_date'] == undefined) {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined) {
      alert(this.To_Date_Msg);
      return;
    }
      
    if (this.model['from_date'] != undefined) {
      this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + ' 00:00:00';
    }
    
    if (this.model['to_date'] != undefined) {
      this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + ' 23:59:59';
    }

    let obj = {
      cmd: 'getAllOperation', from_date: this.from_date, to_date: this.to_date, type: this.model['op_type']
    };

    if (this.model['acct_number'] != '')
      obj['acct_number'] = this.model['acct_number'];

    if (this.model['op_status'] != 'all')
      obj['status'] = this.model['op_status'];

    if (this.model['comment'] != '')
      obj['comment'] = this.model['comment'];

    if (this.model['user_name'] != 'all')
      obj['user_name'] = this.model['user_name'];

    console.log(obj);

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status['msg'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        // this.dp.forEach(element => {
        //   element.op_date = element.op_date.substring(0, 10);
        //   //this.authorities(element.op_type_en);
        // });
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
    html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td><td width="33%"></td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  //*************************** Save More Than One Operation ***************************//
  choose_all() {
    let choose_all = document.getElementById('choose_all') as HTMLInputElement;
    if (choose_all.checked) {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.op_type_en + '_' + element.op_number) as HTMLInputElement;
        choose.checked = true;
      });
    }
    else {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.op_type_en + '_' + element.op_number) as HTMLInputElement;
        choose.checked = false;
      });
    }
  }

  ///////////////////////////////////////////////////////////////////

  save() {

    if (confirm(this.Change_Ops_Msg)) {
      let values = [];
      let where = [];
      let obj;

      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.op_type_en + '_' + element.op_number) as HTMLInputElement;

        //Cancel (delete) operation:
        if (choose.checked && this.model['operation'] == 'Cancel') {
          let return_value = this.operation_type('cancel', element);

          return_value.forEach(element1 => {
            values.push(element1);
          });
        }


        //Change operation status:
        else if (choose.checked && (this.model['operation'] == 'Confirm' || this.model['operation'] == 'Close' || this.model['operation'] == 'Migrate')) {
          let status;

          let return_value = this.operation_type('change_status', element);

          return_value.forEach(element1 => {
            where.push(element1);
          });

          //status type:
          if (this.model['operation'] == 'Confirm')
            status = '2';
          else if (this.model['operation'] == 'Close')
            status = '3';
          else if (this.model['operation'] == 'Migrate')
            status = '4';

          values.push({ 'table_name': element.op_type_en, 'status': status });
        }
      });

      //Save:
      if (this.model['operation'] == 'Cancel')
        obj = { cmd: 'deleteRec', values: values };
      else if (this.model['operation'] == 'Confirm' || this.model['operation'] == 'Close' || this.model['operation'] == 'Migrate')
        obj = { cmd: 'update', values: values, where: where };

      //console.log(obj);
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }


  //*************************** View Operation Detail ***************************//

  view(row) {
    if (row.status != '0') {

      if (row.op_type_en == 'invoice')
        this.router.navigate(['sub_menu/3/invoice_detail/invoice/' + row.op_number + '/operation_list']);
      // { 'type': 'invoice', 'no': row.op_number, 'source': 'operation_list' }

      else if (row.op_type_en == 'return_invoice')
        this.router.navigate(['sub_menu/3/invoice_detail/return_invoice/' + row.op_number + '/operation_list']);
      // { 'type': 'return_invoice', 'no': row.op_number, 'source': 'operation_list' }

      else if (row.op_type_en == 'supplier_invoice')
        this.router.navigate(['sub_menu/3/invoice_detail/supplier_invoice/' + row.op_number + '/operation_list']);
      // { 'type': 'supplier_invoice', 'no': row.op_number, 'source': 'operation_list' }

      else if (row.op_type_en == 'cash_receipt')
        this.router.navigate(['sub_menu/3/receipt_detail/cash_receipt/' + row.op_number]);
      // { 'type': 'cash_receipt', 'no': row.op_number }

      else if (row.op_type_en == 'payment_voucher')
        this.router.navigate(['sub_menu/3/receipt_detail/payment_voucher/' + row.op_number]); // { 'type': 'payment_voucher', 'no': row.op_number }
    }

    //if the operation is deleted (canceled)
    else
      alert(this.Canceled_Op);

  }


  //*************************** Edit Operation ***************************//

  edit(row) {

    if (row.status != '0') {

      //Open new page:

      if (row.op_type_en == 'invoice') {
        if (row.invoice_type == 'program')
          this.router.navigate(['sub_menu/13/reg_on_trip/' + row.trip_id + '/' + row.op_number]);
        // , { 'type': 'invoice', 'mode': 'edit', 'no': row.op_number } , { 'type': 'invoice', 'mode': 'edit', 'no': row.op_number }
        else if (row.invoice_type == 'special_prog')
          this.router.navigate(['sub_menu/13/special_program/' + row.op_number]);
      }

      else if (row.op_type_en == 'supplier_invoice')
        this.router.navigate(['sub_menu/7/supplier_invoice', { 'no': row.op_number }]);

      else if (row.op_type_en == 'journal_entry')
        this.router.navigate(['sub_menu/3/journal_entry', { 'no': row.op_number }]);

      else if (row.op_type_en == 'cash_receipt')
        this.router.navigate(['sub_menu/3/receipt', { 'no': row.op_number, 'type': 'cash_receipt' }]);

      else if (row.op_type_en == 'payment_voucher')
        this.router.navigate(['sub_menu/3/receipt', { 'no': row.op_number, 'type': 'payment_voucher' }]);


      //Pop ups:
      else if (row.op_type_en == 'expenses') {
        let dialog_data = {
          'table_name': 'expenses', 'exp_id': row.exp_id,
          'exp_no': row.op_number,
          'invoice_no': row.invoice_no,
          'invoice_date': row.op_date,
          'amount': row.op_total,
          'flag': 'update',
          'key': 'exp_id',
          'exp_acct': row.acct_number,
          'exp_desc': row.exp_desc,
          'paid_from': row.paid_from,
          'acct_number': row.acct_num,
          'cost_center': row.cost_center,
          'comment': row.comment
        };
        this.expensesDialogRef = this.dialog.open(ExpensesComponent, {
          hasBackdrop: false,
          data: dialog_data,
          width: "90%",
          height: "90%",
        });
        this.expensesDialogRef
          .afterClosed()
          .subscribe(result => {
            this.search();
          });
      }
      else if (row.op_type_en == 'deposit') {
        let dialog_data = {
          'table_name': 'deposit', 'deposit_id': row.deposit_id,
          'deposit_no': row.op_number,
          'from_acct': row.acct_number,
          'deposit_amount': row.op_total,
          'flag': 'update',
          'key': 'deposit_id',
          'to_acct': row.to_acct,
          'deposit_date': row.op_date,
          'deposit_attach': row.deposit_attach,
          'comment': row.comment
        };
        this.dipositDialogRef = this.dialog.open(DepositComponent, {
          hasBackdrop: false,
          data: dialog_data
        });
        this.dipositDialogRef
          .afterClosed()
          .subscribe(result => {
            this.search();
          });
      }
      else if (row.op_type_en == 'transfer') {
        let dialog_data = {
          'table_name': 'transfer', 'trans_id': row.trans_id,
          'trans_no': row.op_number,
          'from_acct': row.acct_number,
          'to_acct': row.to_acct,
          'flag': 'update',
          'key': 'trans_id',
          'trans_amount': row.op_total,
          'trans_date': row.op_date,
          'status': row.status,
          'comment': row.comment
        };
        this.transferDialogRef = this.dialog.open(TransferComponent, {
          hasBackdrop: false,
          data: dialog_data
        });
        this.transferDialogRef
          .afterClosed()
          .subscribe(result => {
            this.search();
          });
      }
    }

    //if the operation is deleted (canceled)
    else
      alert(this.Canceled_Op);
  }


  //*************************** Cancel (Delete) Operation ***************************//

  cancel(row) {

    if (row.status != '0') {

      if (row.op_type_en == 'invoice') {

        // return full invoice
        let dialog_data = [{ 'invoice_no': row.invoice_no, 'invoice_date': row.invoice_date }];
        this.returnDateDialogRef = this.dialog.open(ReturnAllDateComponent, {
          hasBackdrop: false,
          data: dialog_data
        });
        this.returnDateDialogRef
          .afterClosed()
          .subscribe(result => {
            if (result != null && result['op_type'] == 'success') {
              this.utils.returnSaleInvoice(row, result['return_date'], this);
            }
          });
      }

      if (confirm(this.Del_Msg)) {
        let values;

        values = this.operation_type('cancel', row);

        let obj = { cmd: 'deleteRec', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.search();
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }

    //if the operation is deleted (canceled)
    else
      alert(this.Canceled_Op);


  }


  //*************************** Change Operation Status ***************************//

  change_status(row, type) {

    if (row.status != '0') {

      if (confirm(this.Change_Op_Msg)) {
        let where, status, values;

        where = this.operation_type('change_status', row);

        //status type:
        if (type == 'close') {
          values = [{ 'table_name': row.op_type_en, 'is_locked': '1' }];
        }
        else {
          if (type == 'confirm')
            status = '2';
          else if (type == 'migrate') {
            status = '4';
            this.migrate_op();
          }
          values = [{ 'table_name': row.op_type_en, 'status': status }];
        }
        
        let obj = { cmd: 'update', values: values, where: where };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.search();
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }

    //if the operation is deleted (canceled)
    else
      alert(this.Canceled_Op);
  }


  //*************************** For Changing Operation Status ***************************//

  operation_type(type, row) {
    let values;

    //cancel:
    if (type == 'cancel') {
      if (row.op_type_en == 'invoice') {
        values = [{ 'table_name': row.op_type_en, 'invoice_no': row.op_number }];
        values.push({ 'table_name': 'invoice_item', 'invoice_no': row.op_number });
        values.push({ 'table_name': 'inv_payment_method', 'invoice_no': row.op_number });
      }

      else if (row.op_type_en == 'supplier_invoice') {
        values = [{ 'table_name': row.op_type_en, 'invoice_no': row.op_number }];
        values.push({ 'table_name': 'supplier_invoice_item', 'invoice_no': row.op_number });
        values.push({ 'table_name': 'supp_inv_payment_method', 'invoice_no': row.op_number });
      }

      else if (row.op_type_en == 'return_invoice') {
        values = [{ 'table_name': row.op_type_en, 'return_invoice_no': row.op_number }];
        values.push({ 'table_name': 'return_invoice_item', 'return_invoice_no': row.op_number });
        values.push({ 'table_name': 'ret_inv_payment_method', 'return_invoice_no': row.op_number });
      }

      else if (row.op_type_en == 'return_supplier_invoice') {
        values = [{ 'table_name': row.op_type_en, 'return_supplier_invoice_no': row.op_number }];
        values.push({ 'table_name': 'return_supplier_invoice_item', 'return_supplier_invoice_no': row.op_number });
        values.push({ 'table_name': 'ret_supp_inv_payment_method', 'return_supplier_invoice_no': row.op_number });
      }

      else if (row.op_type_en == 'journal_entry')
        values = [{ 'table_name': row.op_type_en, 'entry_no': row.op_number }];

      else if (row.op_type_en == 'cash_receipt') {
        values = [{ 'table_name': row.op_type_en, 'cash_receipt_no': row.op_number }];
        values.push({ 'table_name': 'cash_receipt_acct', 'cash_receipt_no': row.op_number });
        values.push({ 'table_name': 'cash_receipt_invoice', 'cash_receipt_no': row.op_number });
      }

      else if (row.op_type_en == 'payment_voucher') {
        values = [{ 'table_name': row.op_type_en, 'payment_voucher_no': row.op_number }];
        values.push({ 'table_name': 'payment_voucher_acct', 'payment_voucher_no': row.op_number });
        values.push({ 'table_name': 'payment_voucher_invoice', 'payment_voucher_no': row.op_number });
      }

      else if (row.op_type_en == 'expenses')
        values = [{ 'table_name': row.op_type_en, 'exp_no': row.op_number }];

      else if (row.op_type_en == 'deposit')
        values = [{ 'table_name': row.op_type_en, 'deposit_no': row.op_number }];

      else if (row.op_type_en == 'transfer')
        values = [{ 'table_name': row.op_type_en, 'trans_no': row.op_number }];
    }


    //Other status:
    if (type == 'change_status') {
      if (row.op_type_en == 'invoice' || row.op_type_en == 'supplier_invoice')
        values = [{ 'invoice_no': row.op_number }];
      else if (row.op_type_en == 'return_invoice')
        values = [{ 'return_invoice_no': row.op_number }];
      else if (row.op_type_en == 'return_supplier_invoice')
        values = [{ 'return_supplier_invoice_no': row.op_number }];
      else if (row.op_type_en == 'journal_entry')
        values = [{ 'entry_no': row.op_number }];
      else if (row.op_type_en == 'cash_receipt')
        values = [{ 'cash_receipt_no': row.op_number }];
      else if (row.op_type_en == 'payment_voucher')
        values = [{ 'payment_voucher_no': row.op_number }];
      else if (row.op_type_en == 'expenses')
        values = [{ 'exp_no': row.op_number }];
      else if (row.op_type_en == 'deposit')
        values = [{ 'deposit_no': row.op_number }];
      else if (row.op_type_en == 'transfer')
        values = [{ 'trans_no': row.op_number }];
    }

    return values;
  }

  //*************************** Migrate Operation ***************************//

  migrate_op() {

  }


  //*************************** Authorities ***************************//
  // authorities(op_type_en) {
  //   let menu_item_id;
  //   if (op_type_en == 'invoice')
  //     menu_item_id = '15';
  //   else if (op_type_en == 'supplier_invoice')
  //     menu_item_id = '27';
  //   else if (op_type_en == 'return_invoice')
  //     menu_item_id = '88';
  //   else if (op_type_en == 'return_supplier_invoice')
  //     menu_item_id = '27';
  //   else if (op_type_en == 'journal_entry')
  //     menu_item_id = '13';
  //   else if (op_type_en == 'cash_receipt')
  //     menu_item_id = '32';
  //   else if (op_type_en == 'payment_voucher')
  //     menu_item_id = '32';
  //   else if (op_type_en == 'expenses')
  //     menu_item_id = '80';
  //   else if (op_type_en == 'deposit')
  //     menu_item_id = '30';
  //   else if (op_type_en == 'transfer')
  //     menu_item_id = '90';

  //   this.edit_auth = this.utils.getAuth(menu_item_id, this.applicationConstants.EDIT_AUTH);
  //   this.del_auth = this.utils.getAuth(menu_item_id, this.applicationConstants.DELETE_AUTH);
  //   this.view_auth = this.utils.getAuth(menu_item_id, this.applicationConstants.VIEW_AUTH);
  // }
}
